// all constants stored here

export const JOB_TYPES_FOR_JOB_POSTS = [
  "Contract",
  "Freelance",
  "Full-time",
  "Internship",
  "Part-time",
  "Permanent",
  "Seasonal",
];
export const STATUS_TYPES_FOR_JOB_POSTS = ["Active", "Draft", "Inactive"];
export const COMPENSATION_RATES_FOR_JOB_POSTS = [
  "Hourly",
  "Weekly",
  "Annually",
  "Commission",
  "Base and Commission",
];

export const JOB_TYPES = ["Full Time", "Part Time", "Casual", "On-Call"];
export const STATUS_TYPES = ["Active", "R&I", "Closed"];
export const MAX_JOB_DESCRIPTION_LENGTH = 250;
